import { render } from "./TravelContract.vue?vue&type=template&id=258578cd"
import script from "./TravelContract.vue?vue&type=script&lang=js"
export * from "./TravelContract.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LENOVO\\Desktop\\Septem\\mobins.frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__